export function initModal() {
  const loginButtons = document.querySelectorAll(".button-login");
  const modal = document.getElementById("modal");
  const closeButton = document.querySelector(".modal__close-button");
  const registerButton = document.querySelector(".form__button-register");
  const registrationModal = document.getElementById("modal-registration");
  const modalContent = document.querySelector(".modal__content");

  if (modal) {
    loginButtons.forEach(button => {
      button.addEventListener("click", () => {
        if (!modal.classList.contains("active")) {
          modal.classList.add("active");
        }

        if (registrationModal.classList.contains("active")) {
          registrationModal.classList.remove("active");
        }
      });
    });
  }

  if (closeButton) {
    closeButton.addEventListener("click", () => {
      modal.classList.remove("active");
    });
  }

  window.addEventListener("mousedown", event => {
    if (event.target == modal && !modalContent.contains(event.target)) {
      modal.classList.remove("active");
    }
  });

  if (registerButton) {
    registerButton.addEventListener("click", () => {
      if (modal.classList.contains("active")) {
        modal.classList.remove("active");
      }
      if (!registrationModal.classList.contains("active")) {
        registrationModal.classList.add("active");
      }
    });
  }
}

export function initRegistrationModal() {
  const registrationModal = document.getElementById("modal-registration");
  const registrationCloseBtn = document.querySelector(
    ".modal-registration .close-button"
  );
  const registerButtons = document.querySelectorAll(".button-register");
  const modalContent = document.querySelector(".modal-registration__content");

  registerButtons.forEach(button => {
    button.addEventListener("click", () => {
      if (!registrationModal.classList.contains("active")) {
        registrationModal.classList.add("active");
      }
    });
  });

  registrationCloseBtn.addEventListener("click", () => {
    if (registrationModal.classList.contains("active")) {
      registrationModal.classList.remove("active");
    }
  });

  window.addEventListener("mousedown", event => {
    if (
      event.target == registrationModal &&
      !modalContent.contains(event.target)
    ) {
      registrationModal.classList.remove("active");
    }
  });
}

export function initConnectModal() {
  const connectModal = document.getElementById("modal-connect");
  const connectButtons = document.querySelectorAll(".button-connect");
  const connectCloseBtn = document.querySelector(
    ".modal-connect .close-button"
  );
  const modalContent = document.querySelector(".modal-connect__content");
  const body = document.querySelector("body");

  connectButtons.forEach(button => {
    button.addEventListener("click", () => {
      if (!connectModal.classList.contains("active")) {
        connectModal.classList.add("active");
        // body.classList.add("body_lock");
      }
    });
  });

  connectCloseBtn.addEventListener("click", () => {
    connectModal.classList.remove("active");
    // body.classList.remove("body_lock");
  });

  window.addEventListener("mousedown", event => {
    if (event.target == connectModal && !modalContent.contains(event.target)) {
      connectModal.classList.remove("active");
      //  body.classList.remove("body_lock");
    }
  });
}

export function initSendModal() {
  const sendModal = document.getElementById("modal-send");
  const subscribeBtn = document.querySelector(".footer__subscribe-button");
  const cancelBtn = document.querySelector(".form-send .cancel-button");
  const sendCloseBtn = document.querySelector(".modal-send .close-button");
  const modalContent = document.querySelector(".modal-send__content");

  subscribeBtn.addEventListener("click", () => {
    if (!sendModal.classList.contains("active")) {
      sendModal.classList.add("active");
    }
  });

  sendCloseBtn.addEventListener("click", () => {
    sendModal.classList.remove("active");
  });

  cancelBtn.addEventListener("click", () => {
    sendModal.classList.remove("active");
  });

  window.addEventListener("mousedown", event => {
    if (event.target == sendModal && !modalContent.contains(event.target)) {
      sendModal.classList.remove("active");
    }
  });
}

export function initRestoreModal() {
  const restoreModal = document.getElementById("modal-restore");
  const modal = document.getElementById("modal");
  const continueBtn = document.querySelector(".modal-restore .continue-button");
  const closeBtn = document.querySelector(".modal-restore .close-button");
  const restoreBtn = document.querySelector(".modal .form__restore-button");
  const modalContent = document.querySelector(".modal-restore__content");

  if (restoreBtn) {
    restoreBtn.addEventListener("click", () => {
      if (!restoreModal.classList.contains("active")) {
        restoreModal.classList.add("active");
      }

      if (modal.classList.contains("active")) {
        modal.classList.remove("active");
      }
    });
  }

  closeBtn.addEventListener("click", () => {
    restoreModal.classList.remove("active");
  });

  window.addEventListener("mousedown", event => {
    if (event.target == restoreModal && !modalContent.contains(event.target)) {
      restoreModal.classList.remove("active");
    }
  });
}

export function initChangeModal() {
  const modalChange = document.getElementById("modal-change");
  const closeBtn = document.querySelector(".modal-change .close-button");
  const modalContent = document.querySelector(".modal-change__content");

  closeBtn.addEventListener("click", () => {
    modalChange.classList.remove("active");
  });

  window.addEventListener("mousedown", event => {
    if (event.target == modalChange && !modalContent.contains(event.target)) {
      modalChange.classList.remove("active");
    }
  });
}

export function showModalSuccess() {
  const modalSuccess = document.querySelector(".modal-success");
  const closeSuccessBtn = document.querySelector(".modal-success .close");
  const backBtn = document.querySelector(".modal-success .button-back");
  const modalContent = document.querySelector(".modal-success__content");

  modalSuccess.classList.add("active");

  closeSuccessBtn.onclick = function () {
    modalSuccess.classList.remove("active");
  };

  backBtn.onclick = function () {
    modalSuccess.classList.remove("active");
  };

  window.addEventListener("mousedown", event => {
    if (event.target == modalSuccess && !modalContent.contains(event.target)) {
      modalSuccess.classList.remove("active");
    }
  });
}

export function showCodeSuccess() {
  const modalCodeSuccess = document.getElementById("modal-code");
  const modalChange = document.getElementById("modal-change");
  const closeSuccessBtn = document.querySelector(".modal-code .close-button");
  const modalContent = document.querySelector(".modal-code__content");
  const changeBtn = document.querySelector(".modal-code__button");

  modalCodeSuccess.classList.add("active");

  closeSuccessBtn.onclick = function () {
    modalCodeSuccess.classList.remove("active");
  };

  changeBtn.onclick = function () {
    modalCodeSuccess.classList.remove("active");
    modalChange.classList.add("active");
  };

  window.addEventListener("mousedown", event => {
    if (
      event.target == modalCodeSuccess &&
      !modalContent.contains(event.target)
    ) {
      modalCodeSuccess.classList.remove("active");
    }
  });
}

export function showSuccessMessage() {
  const modalSuccess = document.querySelector(".modal-success");
  const successMessage = document.querySelector(".modal-consult__content");
  const consultContent = document.querySelector(".consultation__content");
  const againBtn = document.querySelector(".modal-consult__button");

  if (!(modalSuccess && successMessage && consultContent && againBtn)) return;

  successMessage.style.display = "block";
  consultContent.style.display = "none";

  againBtn &&
    againBtn.addEventListener("click", function () {
      successMessage.style.display = "none";
      consultContent.style.display = "block";
    });
}
